import { render, staticRenderFns } from "./InstanceHistory.vue?vue&type=template&id=47e1b9ce&lang=pug"
import script from "./InstanceHistory.vue?vue&type=script&lang=js"
export * from "./InstanceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports